import { httpClient } from './httpClient'
import type { ApiResponse } from '../types'
import type { components } from '../../../../../types/gridx-api'

type SystemWithGateways = components['schemas']['SystemWithoutProductOption']
export type EVChargingStationConfiguration = components['schemas']['EVChargingStationConfiguration']
export type ElectricVehicleProfile = components['schemas']['ElectricVehicleProfile']
export type EVStationMeasurement = components['schemas']['EVStationMeasurement']
type SystemLiveMeasurement = components['schemas']['Measurement']

const V2_ACCEPT = 'application/vnd.gridx.v2+json'

export async function getSystemWithGateways(
  systemID: string
): Promise<ApiResponse<SystemWithGateways>> {
  try {
    const response = await httpClient
      .getClient()
      .get<SystemWithGateways>(`/systems/${systemID}`, {
        params: { include: 'gateways' },
        headers: { Accept: V2_ACCEPT },
      })
    return { success: true, data: response.data }
  } catch (error: any) {
    return {
      success: false,
      error: error.message || 'Failed to get system gateways',
      errorCode: error.code || 'UNKNOWN_ERROR',
      details: error.details,
    }
  }
}

export async function getEVConfiguration(
  gatewayID: string,
  applianceID: string
): Promise<ApiResponse<EVChargingStationConfiguration>> {
  try {
    const response = await httpClient
      .getClient()
      .get<EVChargingStationConfiguration>(
        `/gateways/${gatewayID}/appliances/${applianceID}/ev/configuration`,
        { headers: { Accept: V2_ACCEPT } }
      )
    return { success: true, data: response.data }
  } catch (error: any) {
    return {
      success: false,
      error: error.message || 'Failed to get EV configuration',
      errorCode: error.code || 'UNKNOWN_ERROR',
      details: error.details,
    }
  }
}

export async function getSystemLiveMeasurements(
  systemID: string
): Promise<ApiResponse<SystemLiveMeasurement>> {
  try {
    const response = await httpClient
      .getClient()
      .get<SystemLiveMeasurement>(`/systems/${systemID}/live`, {
        headers: { Accept: V2_ACCEPT },
      })
    return { success: true, data: response.data }
  } catch (error: any) {
    return {
      success: false,
      error: error.message || 'Failed to get live measurements',
      errorCode: error.code || 'UNKNOWN_ERROR',
      details: error.details,
    }
  }
}

export async function listEVProfiles(
  systemID: string
): Promise<ApiResponse<ElectricVehicleProfile[]>> {
  try {
    const response = await httpClient
      .getClient()
      .get<ElectricVehicleProfile[]>(`/systems/${systemID}/ev-profiles`, {
        headers: { Accept: V2_ACCEPT },
      })
    return { success: true, data: response.data }
  } catch (error: any) {
    return {
      success: false,
      error: error.message || 'Failed to list EV profiles',
      errorCode: error.code || 'UNKNOWN_ERROR',
      details: error.details,
    }
  }
}
